import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Avatar, Button, Text, Heading, Flex, AlertDialog, Spinner } from '@radix-ui/themes';
import { updateUser } from '../../redux/slices/userSlice'
import { updateAccount } from '../../redux/slices/accountSlice'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import api from '../../api';
import { usePaystackPayment } from 'react-paystack';

const GuardianProfiles = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const account = useSelector((state) => state.account);
    const user = useSelector((state) => state.user);
    // const guardian = useSelector((state) => state.guardian);
    const [wards, setWards] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isConfirmLoginOpen, setIsConfirmLoginOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const PAYSTACK_PUBLIC_KEY = import.meta.env.VITE_PAYSTACK_PUBLIC_KEY

    useEffect(() => {
        const getWards = async () => {
            try {
                setLoading(true);
                const wardsResponse = await api.get(`guardians/students/${account.details.id}`);
                setWards(wardsResponse.data.data);

                console.log('guardians/students', wardsResponse.data.data);

            } catch (error) {
                console.error('Error fetching wards:', error);
            } finally {
                setLoading(false);
            }
        };
        getWards();
    }, [account.details.id]);

    // Confirm Login 
    const handleConfirmLogin = async () => {

        try {
            const response = await api.post(`/login-with-id/${selectedUser.id}`)
            const loginData = response.data

            localStorage.setItem('guardianUserId', user.details.id)

            // console.log('data after login', loginData);
            localStorage.setItem('authToken', loginData.user.authToken)
            dispatch(updateUser(loginData.user));
            dispatch(updateAccount(loginData.account));

            navigate('/student')
        } catch (error) {
            toast.error("Couldn't login to account, Try again", {
                position: "bottom-right"
            })
        }
    }

    /**
     * Opens the confirm login dialog with the selected ward's user
     * @param {Object} ward - The selected ward object
     */
    const handleOpenConfirmLogin = (ward) => {
        setSelectedUser(ward.user);
        setIsConfirmLoginOpen(true);
    }


    const handleSubscribe = async (paymentResponse, ward) => {
        try {
            const userData = {
                student_id: ward.id,
                received_from_id: account.details.id,
                payment_method: '',
                received_from_type: user.details.role == 'student' ? 'App\\Models\\student' : 'App\\Models\\Guardian',
                payment_details: JSON.stringify(paymentResponse),
            }
            console.log('submitted data', userData);

            const response = await api.post(`/make-payment`, userData)
            const data = response.data

            console.log('payment response data::', data)

            const updatedStudents = guardian.students.map((student) =>
                student.id === ward.id
                    ? {
                        ...student,
                        payment_details: data.payment_details,
                    }
                    : student
            );

            dispatch(updateStudents(updatedStudents));

            toast.success("You've upgraded the account for this ward", {
                position: "bottom-right"
            })


        } catch (error) {
            console.log('error on payment:', error);
            toast.error("Couldn't subscribe to the Advantage plan", {
                position: "bottom-right"
            })
        }
    };

    const handleUpgradeClick = (ward) => {
        const paystackProps = {
            reference: new Date().getTime().toString(),
            currency: 'GHS',
            email: ward.user.email || user.details.email,
            amount: ward.subscriptionAmount || 4000, // Dynamically set the amount based on ward details
            publicKey: PAYSTACK_PUBLIC_KEY,
        };

        const initializePayment = usePaystackPayment(paystackProps);

        // Trigger payment
        initializePayment({
            onSuccess: (reference) => onSuccess(reference, ward),
            onClose,
        });
    };

    // Success callback function
    const onSuccess = (reference, ward) => {
        // console.log("Payment successful, reference:", reference, ward);
        handleSubscribe(reference, ward);
    };

    // Close callback function
    const onClose = () => {
        console.log("Payment dialog closed");
    };


    return (
        <Flex direction="column" width="100%" align="center" mt="4">
            <Box border="1px solid" p="4" maxWidth="450px" textAlign="center">
                <Heading textAlign="center" size="md" mb="4">
                    Choose an account
                </Heading>

                {loading ? (
                    <Flex className="flex flex-col items-center justify-center w-full">
                        <Spinner size="4" />
                    </Flex>
                ) : (
                    <>
                        {wards.map((ward) => (
                            <div
                                key={`w${ward.id}`}
                                className="p-3 flex cursor-pointer flex-row items-center w-[410px] justify-between gap-4 rounded shadow bg-white border border-gray-200 mb-3 hover:bg-gray-100" // hover effect here

                            >
                                <div
                                    className='flex flex-row cursor-pointer items-center gap-4'
                                    onClick={() => handleOpenConfirmLogin(ward)}
                                >
                                    <Avatar
                                        fallback={`${ward.user.firstname?.charAt(0) || 'U'}`}
                                        radius="full"
                                        size="4"
                                    />
                                    <div className="flex flex-col justify-between">
                                        <p className="text-base font-bold text-left">
                                            {ward.user.firstname || 'Unknown'} {ward.user.lastname || 'User'}
                                        </p>
                                        <p className="text-sm text-gray-600 text-left">
                                            Click to Login as {ward.user.firstname || 'Unknown'} {ward.user.lastname || 'User'}
                                        </p>
                                    </div>
                                </div>
                                <Button
                                    aria-label={`Upgrade for ${ward.user.firstname || 'Unknown'}`}
                                    className={`cursor-pointer ml-auto ${ward?.payment_details?.status === 'active' ? 'bg-indigo-500' : 'bg-green-500'}`}
                                    color={ward?.payment_details?.status === 'active' ? 'indigo' : 'green'}
                                    disabled={ward?.payment_details?.status === 'active'}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleUpgradeClick(ward)
                                    }}
                                >
                                    {ward?.payment_details?.status === 'active'
                                        ? `Expires in ${ward?.payment_details?.details?.end_date
                                            ? DateTime.fromISO(ward.payment_details.details.end_date).toFormat('d MMMM yyyy')
                                            : 'Unknown Date'
                                        }`
                                        : 'Upgrade'}
                                </Button>
                            </div>
                        ))}

                    </>
                )}

                <div
                    className="p-3 cursor-pointer flex flex-row items-center w-[410px] gap-4 rounded shadow bg-white border border-gray-200 mb-3 hover:bg-gray-100" // hover effect here
                    onClick={() => navigate('/guardian')}
                >
                    <Avatar
                        src={user.details.profile_picture || "https://placecats.com/300/200"}
                        fallback={`${user.details.firstname?.charAt(0) || 'U'}`}
                        radius="full"
                        size="4"
                    />
                    <div className="flex flex-col justify-between">
                        <p className="text-base font-bold text-left">
                            {user.details.firstname || 'Unknown'} {user.details.lastname || 'User'}
                        </p>
                        <p className="text-sm text-gray-600 text-left">
                            Click to continue as Guardian
                        </p>
                    </div>
                </div>



                <AlertDialog.Root open={isConfirmLoginOpen} onOpenChange={setIsConfirmLoginOpen}>
                    <AlertDialog.Content className="bg-white p-4 rounded shadow-lg w-1/3 mx-auto">
                        <AlertDialog.Title>Confirm Login</AlertDialog.Title>
                        <AlertDialog.Description>
                            Are you sure you want to login as {selectedUser?.firstname}  {selectedUser?.lastname}
                        </AlertDialog.Description>
                        <div className="flex justify-end gap-4 mt-4">
                            <Button className='cursor-pointer' variant="soft" onClick={() => setIsConfirmLoginOpen(false)}>
                                Cancel
                            </Button>
                            <Button className='cursor-pointer' variant="solid" color="green" onClick={handleConfirmLogin}>
                                Continue
                            </Button>
                        </div>
                    </AlertDialog.Content>
                </AlertDialog.Root>
            </Box>
        </Flex>
    );

};

export default GuardianProfiles;

